import CloseIcon from '@mui/icons-material/Close';
import { observer } from 'mobx-react-lite';
import { formatDate, formatFileSize } from '../utils/utils';
import styles from './AttachmentFile.module.css';
import commonStyles from './Common.module.css';

function AttachmentFile({ name, url, updatedAt, size, onDeleteClick }: IAttachmentFileProps) {

    return (
        <div className={styles.container}>
            <div className={styles.info}>
                <div className={styles.header}>
                    {url ? <a href={url} className={commonStyles.link} target="_blank">{name}</a> : name}
                </div>
                <div>
                    {[!!updatedAt && formatDate(updatedAt), formatFileSize(size)].filter(d => d).join(" - ")}
                </div>
            </div>
            {onDeleteClick && <CloseIcon fontSize="small" className={commonStyles.clickableIcon} onClick={onDeleteClick} />}
        </div>
    );
}

export default observer(AttachmentFile);

interface IAttachmentFileProps {
    name: string;
    url?: string;
    updatedAt?: Date;
    size: number;
    onDeleteClick?: () => void;
}
